import { Drawer, makeStyles, createStyles } from '@material-ui/core'
import { SideBarItems } from './SideBarItems'
import { bool, func } from 'prop-types'

const useStyles = makeStyles((theme) =>
  createStyles({
    drawerPaper: {
      width: 250,
    },
  }),
)

const SideBar = ({ open, onClose }) => {
  const classes = useStyles()

  return (
    <Drawer
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <SideBarItems onClose={onClose} />
    </Drawer>
  )
}

export default SideBar

SideBar.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
}
